import type { Locale } from 'date-fns';
import { LocaleMap } from 'models/date-locale';
import { getCurrentLocaleFormat } from './get-locale-format';

export const getDateFnsLocale = (): Locale => LocaleMap[getCurrentLocaleFormat().language];
